import { z } from 'zod';
import { isAcceptedSpecModelProfile, isSpecModelProvider } from './spec-models.js';

/** A model row as an operator files it (`infra/spec/models/*.json`); class, version and label are assigned on switch. */
export const SpecModelRowSchema = z
  .object({
    provider: z.string().refine(isSpecModelProvider, { message: 'Unknown Spec model provider.' }),
    providerModelId: z.string().trim().min(1),
    profile: z.string().trim().min(1),
    enabledPurposes: z.array(z.enum(['chat', 'title', 'tool-routing', 'compaction'])).min(1),
    contextTokenLimit: z.number().int().positive(),
    outputTokenLimit: z.number().int().positive(),
    inputMicrousdPerMillion: z.number().int().nonnegative(),
    cachedInputMicrousdPerMillion: z.number().int().nonnegative(),
    cacheWriteMicrousdPerMillion: z.number().int().nonnegative().nullable(),
    outputMicrousdPerMillion: z.number().int().nonnegative(),
    longContextThresholdTokens: z.number().int().positive().nullable(),
    longContextMultiplierPpm: z.number().int().positive(),
    tokenEstimateMultiplierPpm: z.number().int().positive(),
    landedCostMultiplierPpm: z.number().int().positive(),
    fixedMicrousdPerRequest: z.number().int().nonnegative(),
  })
  .strict()
  .superRefine((row, ctx) => {
    if (!isAcceptedSpecModelProfile(row.provider, row.profile)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['profile'],
        message: 'This provider does not accept that profile.',
      });
    }
    if (new Set(row.enabledPurposes).size !== row.enabledPurposes.length) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['enabledPurposes'],
        message: 'Purposes repeat.',
      });
    }
  });

export type SpecModelRow = z.infer<typeof SpecModelRowSchema>;
